import React from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getMessageProps, getClass } from 'Store/reducers';
import { CANONICAL_URL, appDataByKey } from 'Settings';
import { ROUTES } from 'Settings/route-strings';

const getPageIdByRoute = route => {
  switch (route) {
    case ROUTES.SIGN_IN:
      return 'sign_in_page';
    case ROUTES.SIGN_OUT:
      return 'sign_out_page';
    case ROUTES.RESET_PASSWORD:
    case `${ROUTES.RESET_PASSWORD}/:resetPasswordToken`:
      return 'reset_password_page';
    case ROUTES.EXPLORE:
      return 'explore_page';
    case ROUTES.CLASSES:
      return 'classes_page';
    case `${ROUTES.INVITES}/:inviteToken`:
      return 'create_account_page';
    default:
      return null;
  }
};

const DocumentHead = props => {
  const { title, metaTitle, canonicalURL } = props;
  return (
    <Helmet>
      <title>{`${metaTitle}${title ? ` - ${title}` : ''}`}</title>
      <link rel="canonical" href={canonicalURL} />
    </Helmet>
  );
};

const mapStateToProps = (state, props) => {
  const {
    match: { params },
    location,
    // routes,
    intl,
  } = props;

  const getTitleByPath = path => {
    const id = getPageIdByRoute(path);
    if (id === null) return null;
    return intl.formatMessage(getMessageProps(state, `${id}.meta.title`));
  };

  // console.log('props', props);
  const propList = {
    canonicalURL: CANONICAL_URL + location.pathname,
    // TODO: investigate former approach: routes[1].title
    title: getTitleByPath(location.pathname),
    metaTitle: intl.formatMessage(getMessageProps(state, 'meta.title')),
  };

  // TODO: params not working
  if (params.classId) {
    const _class = getClass(state, params.classId);
    return {
      ...propList,
      type: 'class',
      title: _class ? _class.name : null,
    };
  }

  // TODO: params not working
  if (params.gameSlug) {
    const messageId = `model.${params.gameSlug}.title`;
    return {
      ...propList,
      type: 'app',
      title: intl.formatMessage(getMessageProps(state, messageId)),
    };
  }
  return propList;
};

export default injectIntl(
  withRouter(connect(mapStateToProps, false)(DocumentHead))
);
